/**
 * MasterLayout - wrapper for primary page render, includes header, sidebar etc.
 */
import { SIDEBAR_VISIBLE } from '../../constants/cookieKeys'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import NavigationHeader from '../navigationHeader'
import NavigationHeader2026 from '../navigationHeader/v2026'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class MasterLayout extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    router: PropTypes.func.isRequired,
    featureFlags: PropTypes.object,
    cookies: PropTypes.object,
    customLogo: PropTypes.string,
    permissions: PropTypes.object.isRequired,
    displayName: PropTypes.string,
    cls: PropTypes.string,
  }

  static defaultProps = {
    featureFlags: {},
  }

  constructor(props) {
    super(props)

    const { cookies } = props
    let visible = cookies ? cookies.get(SIDEBAR_VISIBLE) : 'true'
    visible = visible !== 'false'
    this.state = { visible }
  }

  state = {
    visible: true,
  }

  onSidebarMenuToggle = () => {
    const { cookies } = this.props
    const { visible } = this.state

    this.setState({
      visible: !visible,
    })

    if (cookies) {
      cookies.set(SIDEBAR_VISIBLE, !visible, { path: '/' })
    }
  }

  render() {
    const {
      match,
      router,
      featureFlags,
      cookies,
      customLogo,
      permissions,
      displayName,
      cls,
    } = this.props

    return (
      <div className={cx('container', cls)}>
        <div className={cx('main-header')}>
          {featureFlags['fe.resi.morpheus-menu-2026'] ? (
            <NavigationHeader2026
              onSidebarMenuToggle={this.onSidebarMenuToggle}
              cookies={cookies}
              customLogo={customLogo}
              permissions={permissions}
              displayName={displayName}
              featureFlags={featureFlags}
            />
          ) : (
            <NavigationHeader
              onSidebarMenuToggle={this.onSidebarMenuToggle}
              cookies={cookies}
              customLogo={customLogo}
              permissions={permissions}
              displayName={displayName}
              featureFlags={featureFlags}
            />
          )}
        </div>

        <div className='full-height'>
          {router(match, featureFlags, permissions)}
        </div>
      </div>
    )
  }
}

export default MasterLayout
